import { ESteps } from 'src/components/transactions/steps';

const getTransactionStatus = (stepNumber: number, isComplete: boolean) => {
  let status = '';

  if (stepNumber >= 0) status = ESteps.WaitingForTransaction;
  if (stepNumber >= 0) status = ESteps.TransactionDetected;
  if (stepNumber >= 1 || isComplete) status = ESteps.TransactionPartiallyConfirmed;
  if (isComplete) status = ESteps.TransactionCompleted;

  return status;
};

export { getTransactionStatus };
